import React, { Component, useEffect, useState } from "react";
import { auth, data } from "./firebase";
import "./css/Int.css";
import ScheduleIcon from "@material-ui/icons/Schedule";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
function Int() {
  const [usesa, setUs] = useState([]);
  useEffect(() => {
    get();
  }, []);
  function get() {
    data
      .collection("Products")
      .get()
      .then((item) => {
        const items = item.docs.map((doc) => doc.data());

        setUs(items);
      });
  }
  var c=0
  return (
    <div class="scrolling">
      {usesa.filter((val)=>{
          c++
          if(c<8){
              return val
          }
      }).map((e, index) => {
        var link = "/Product/"+e.id
        return (
          <a className="BOXa" href={link}>
            <div className="imgbox">
              <img src={e.img} />
              <span></span>
              <span>
                <ScheduleIcon className="i" />
                {e.Day} {e.DayNum} à {e.Time}
              </span>
            </div>
            <div className="txtbox">
              <p>{e.prix}</p>
              <span>{e.type}</span>
            </div>
          </a>
        );
      })}
    </div>
  );
}

export default Int;
